import {blueColor, DodgerBlueColor, oceanBlueColor} from '../../cmsMainStyle'

const viewDrawingFormStyle = theme => ({

	fieldGridArea: {
		textAlign: "center",
		marginTop: theme.spacing(1),
	},

	fieldGrid: {
		textAlign: "center",
		marginTop: theme.spacing(2),
	},

	ToggleButtonGroup: {
		width: "100%",
	},

	ToggleButton_25: {
		width: "25%",

		"&.Mui-selected": {
			backgroundColor: oceanBlueColor[1]
		}
	},

	ToggleButton_33: {
		width: "33.33%",

		"&.Mui-selected": {
			backgroundColor: oceanBlueColor[1]
		}
	},

	ToggleButton_50: {
		width: "50%",

		"&.Mui-selected": {
			backgroundColor: oceanBlueColor[1]
		}
	},

	formControl: {
		minWidth: "100%",
		textAlign: 'left',
	},


	tagBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},
	},

	tagArea: {
		height: theme.spacing(15),
		padding: theme.spacing(1),
		textAlign: "left",
	},

	datePickerField: {
		width: '100%',
	},

	toolMenuBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},
	},

	validationErrorMsg: {
		marginTop: "5px",
		marginLeft: "16px",
		textAlign: "left",
	},

	chips: {
		display: 'flex',
		flexWrap: 'wrap',
	},

	chip: {
		margin: 2,
		backgroundColor: oceanBlueColor[8]
	},
})


export {viewDrawingFormStyle}